import { FAILURE, REQUEST } from '../constants/constants';
import { toast } from 'react-toastify';
import { getLogger } from '../../lib/devMode';
import {TOKEN_ERROR_LIST} from "../constants/checkoutConstants";

const createPostParams = (data) => {
    const form = new FormData();
    for (let key in data) {
        form.append(key, data[key]);
    }

    const formData = new URLSearchParams();
    for (const pair of form) {
        formData.append(pair[0], pair[1]);
    }

    return {
        method: 'POST',
        body: form,
    };
};

export default () => (next) => async (action) => {
    let errorFlag = false;
    if (!action.CallAPI) return next(action);

    const { CallAPI, type, postData, ...rest } = action;
    next({ ...rest, type: type + REQUEST });

    try {
        const APIUrl = CallAPI;
        const params = postData ? createPostParams(postData) : {};

        const res = await fetch(APIUrl, params);

        if (!res.ok) {
            if (res.statusText) {
                throw res.statusText;
            } else {
                errorFlag = true;
            }
        }

        const apiData = await res.json();

        if (apiData?.error_no) {
            if ((TOKEN_ERROR_LIST.includes(apiData?.error_message) && rest.showTokenError) || action?.showError ) {
                return {...rest, apiData};
            } else {
                throw (`Failure: ${apiData.error_message} (code: ${apiData.error_no})`)
            }
        } else if (errorFlag) {
            throw new Error('Technical error occurred');
        }

        next({ ...rest, type, apiData });
        return { ...rest, apiData };
    } catch (apiError) {

        if (action?.showError !== false) {
            toast.error(apiError || 'Technical error occurred')
        }

        getLogger().error(apiError)
        return next({ ...rest, type: type + FAILURE, error: apiError, errorProcessed: true });
    }
};
